export default __webpack_public_path__ + "static/media/recorte_17.5db6e8eb.JPG";